const getOption = key => (window.runtime && window.runtime[key]) || process.env[key];

export default {
  api: {
    enabled: true,
    baseUrl: getOption('REACT_APP_API_URL')
  },
  liveApi: {
    enabled: true,
    url: getOption('REACT_APP_LIVE_URL'),
    worker: "/static/js/worker.js",
    maxDelay: 300000,
    interval: 250,
    maxAge: 900000
  },
  social: {
    facebookAppId: getOption('REACT_APP_FACEBOOK_APP_ID')
  },
  fragments: {
    url: getOption('REACT_APP_STREAM_SHARE_URL'),
    eventAddToEndSeconds: 5,
    eventSubtractFromStartSeconds: 0
  },
  theoplayer: {
    url: getOption('REACT_APP_THEOPLAYER_URL'),
  },
  chromecast: {
    gStaticUrl: getOption('REACT_APP_CHROMECAST_GSTATIC_URL'),
    appId: getOption('REACT_APP_CHROMECAST_APPLICATION_ID')
  },
  stats: {
    baseUrl: getOption('REACT_APP_PIWIK_URL')
  },
  status: {
    baseUrl: getOption('REACT_APP_STATUS_URL'),
    interval: 300
  },
  auth: {
    baseUrl: getOption('REACT_APP_AUTH_URL'),
    clientId: getOption('REACT_APP_AUTH_CLIENT_ID'),
    userPoolId: getOption('REACT_APP_AUTH_USER_POOL_ID'),
    region: getOption('REACT_APP_AUTH_REGION'),
    identityPoolId: getOption('REACT_APP_AUTH_IDENTITY_POOL_ID'),
    mxfBucket: getOption('REACT_APP_AUTH_MXF_BUCKET'),
  },
  share: {
    url: getOption('REACT_APP_SHARE_URL')
  },
  date: {
    fromDate: getOption('REACT_APP_DATE_FROM_DATE'),
  },
  search: {
    url: getOption('REACT_APP_ELASTIC_URL'),
    debateIndex: getOption('REACT_APP_ELASTIC_DEBATE_INDEX'),
    eventIndex: getOption('REACT_APP_ELASTIC_EVENT_INDEX'),
  },
  staticUrl: getOption('REACT_APP_STATIC_URL'),
  baseUrl: getOption('REACT_APP_BASE_URL') || "",
}




// WEBPACK FOOTER //
// ./src/config.js